import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GoToastModule } from '@go-modules/components/go-toast/go-toast.module';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { AccountMenuComponent } from './account-menu.component';
import { AdminPanelModule } from '@go-modules/components/sidepanels/admin-panel/admin-panel.module';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		GoToastModule,
		AdminPanelModule
	],
	declarations: [
		AccountMenuComponent
	],
	exports: [
		AccountMenuComponent
	]
})
export class AccountMenuModule {}
